export default __webpack_public_path__ + "static/product_sans_regular-webfont-c4538690d4ebd039a733eecaceb795db.woff2";